import { NgxCookiebotConfig } from '@halloverden/ngx-cookiebot';

export class CookiebotConfig extends NgxCookiebotConfig {
  override blockingMode = 'manual';
  override cbId = 'f79794f9-d26b-4837-9574-45ba51d3cba2';
  override cdn = 'eu';
  override loadScript = true;
}
